import React from 'react';

export const CrumbsContext = React.createContext({
    crumbs: [],
    setCrumbs: () => {
    }
});
